import React, { useEffect, useState } from 'react';
import './styles.scss';
import { TCustomCarouselDotsProps } from './types/customCarouselDots.types';

const Dots = (props: { class: string }): JSX.Element => {
  return <span className={`carousel-dots__item carousel-dots__item--${props.class}`}></span>;
};

const CustomCarouselDots = (props: TCustomCarouselDotsProps): JSX.Element => {
  const dotsArray: JSX.Element[] = [];
  const visibleDots = 5;
  const [min, updateMin] = useState(1);
  const [max, updateMax] = useState(visibleDots); // min 5 cards to be shown
  const [changes, updateChanges] = useState(0);

  useEffect(() => {
    let initialMax = max;
    let initialMin = min;

    if (props.activeCard < initialMin) {
      initialMin = props.activeCard;
      initialMax = initialMin + 4;
      if (initialMax > changes + 1) {
        initialMax = changes + 1;
      }
    }

    if (props.activeCard > initialMax) {
      initialMax = props.activeCard;
      initialMin = initialMax - 4;
      if (initialMin < 0) {
        initialMin = 0;
      }
    }

    updateMax(initialMax);
    updateMin(initialMin);
    updateChanges(changes + 1);
  }, [props.activeCard]);

  const getIndicatorClass = (ref: number): string => {
    if (ref === props.activeCard) {
      return 'active';
    }

    // if items are 5 return for always the same width
    if (props.cardsCount <= visibleDots) {
      return 'std';
    }

    // if not, then check if we are in the range of 5 items if yes return standard dimension
    if (ref >= min && ref <= max) {
      return 'std';
    }

    // if not, then check if we are before one or after one in the range of 5, if yes return small dimension
    if (ref === min - 1 || ref === max + 1) {
      return 'small';
    }

    // if not hidden the dot
    return 'hidden';
  };

  for (let i = 1; i <= props.cardsCount; i++) {
    dotsArray.push(<Dots class={getIndicatorClass(i)} key={i} />);
  }
  return (
    <div
      className={`carousel-dots__wrapper ${props?.hasAnimation ? ' carousel-dots--animation' : ''} ${
        props?.isDarkMode ? ' carousel-dots--dark-mode' : ''
      }`}
    >
      {dotsArray}
    </div>
  );
};

export default CustomCarouselDots;
